<span class="productMapper vetcorPrice">
   <section class="p-2 mt-2">
      <div
         *ngIf="practice()"
         class="stepper-page">
         <div class="submission-deadline">
            DEADLINE FOR SUBMISSION:
            {{ activeCycle()?.discussionComplete | date : "EEEE, MMMM d" }}{{ activeCycle()?.discussionComplete | date : "d" | ordinal }}
         </div>
         <div
            *ngIf="!selectedPracticeSKey()"
            style="padding: 10px; vertical-align: top">
            <div class="alert alert-info text-center">Please select a hospital above.</div>
         </div>

         <div
            id="statsAdminDiv"
            class="d-flex flex-row mb-0">
            <vc-practice-select
               urlBase="vetcor-pricing/admin"
               [autoselect]="false"
               [onlySourcePractices]="true" />

            <div class="arButtons">
               <div
                  *ngIf="activeCycle()?.writebackSuccess && activeCycle()?.writebackSuccess >= 0"
                  class="arWriteback ml-auto">
                  <div class="arWriteback-text">Writeback Success</div>
                  <div
                     *ngIf="activeCycle()?.writebackSuccess && activeCycle()?.writebackSuccess >= 0"
                     class="practiceWritebackStatus"
                     [ngClass]="getStatusBackgroundColorClass(activeCycle()?.writebackSuccess)">
                     {{ activeCycle()?.writebackSuccess | percent : "1.0-2" }}
                  </div>
               </div>

               <div
                  *ngIf="activeCycle()?.batchStatus != 3"
                  class="arPracticeButtons">
                  <button
                     id="adminApproveAllButton"
                     class="v-button v-button-md v-green"
                     (click)="approveAllPricingUpdateRequests()">
                     <i class="fa fa-check"></i>
                     &nbsp;&nbsp;{{ showOnlyUnreviewedProducts() ? "&nbsp;Approve Selected" : "&nbsp;Approve Practice Requests" }}
                  </button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <button
                     id="adminRejectAllButton"
                     class="v-button v-button-md v-red"
                     (click)="rejectAllPricingUpdateRequests()">
                     <i class="fa fa-remove"></i>
                     &nbsp;&nbsp;{{ showOnlyUnreviewedProducts() ? "&nbsp;Reject Selected" : "&nbsp;Reject Practice Requests" }}
                  </button>
               </div>

               <div
                  *ngIf="selectedPracticeSKey()"
                  class="arHospitalInfo">
                  <div style="width: 100%">
                     <span style="font-weight: 700">Hospital Manager:</span>
                     {{ firstHm()?.firstName }} {{ firstHm()?.lastName }}
                  </div>
                  <div style="height: 1px"></div>
                  <div style="width: 100%">
                     <span style="font-weight: 700">Chief of Staff:</span>
                     {{ practice()?.cos?.firstName }} {{ practice()?.cos?.lastName }}
                  </div>
                  <div style="height: 1px"></div>
                  <div style="width: 100%; color: #02a09e">
                     <span style="font-weight: 700">Has ProSal DVM:</span>
                     <span style="text-transform: uppercase">{{ practice()?.hasProSal }}</span>
                  </div>
               </div>
            </div>
         </div>

         <div class="admin-practice-stats">
            <div class="averagePriceChanges">
               <ng-container>
                  <div class="innerPriceChanges">
                     <div
                        style="display: inline-block; vertical-align: top; color: #0572ba"
                        class="innerPct">
                        <span style="font-size: 14px">{{ activeCycle()?.modelAverageChangePct | currency : "USD" : "symbol" : "1.2-2" }}</span>
                        <br />
                        <span style="color: #a2a2a2">Modeled Avg % Price Change</span>
                        <div style="height: 10px"></div>

                        <span style="font-size: 14px">
                           {{ activeCycle()?.modeledWeightedImpactChangePct | currency : "USD" : "symbol" : "1.2-2" }}
                        </span>
                        <br />
                        <span style="color: #a2a2a2">Modeled Weighted Avg % Price Change</span>
                        <div style="height: 10px"></div>

                        <span style="font-size: 14px">{{ activeCycle()?.revenueImpact | currency : "USD" : "symbol" : "1.2-2" }}</span>
                        <br />
                        <span style="color: #a2a2a2">Modeled $ Impact</span>
                     </div>

                     <div
                        style="display: inline-block; vertical-align: top; color: #8d198b"
                        class="innerPct">
                        <span style="font-size: 14px">{{ activeCycle()?.requestedAverageChangePct | currency : "USD" : "symbol" : "1.2-2" }}</span>
                        <br />
                        <span style="color: #a2a2a2">Requested Avg % Price Change</span>
                        <div style="height: 10px"></div>

                        <span style="font-size: 14px">
                           {{ activeCycle()?.requestedWeightedImpactChangePct | currency : "USD" : "symbol" : "1.2-2" }}
                        </span>
                        <br />
                        <span style="color: #a2a2a2">Requested Weighted Avg % Price Change</span>
                        <div style="height: 10px"></div>

                        <span style="font-size: 14px">{{ activeCycle()?.requestedRevenueImpact | currency : "USD" : "symbol" : "1.2-2" }}</span>
                        <br />
                        <span style="color: #a2a2a2">Requested $ Impact</span>
                     </div>
                     <div
                        style="display: inline-block; vertical-align: top; color: #02a09e"
                        class="innerPct">
                        <span style="font-size: 14px">{{ activeCycle()?.finalAverageChangePct | currency : "USD" : "symbol" : "1.2-2" }}</span>
                        <br />
                        <span style="color: #a2a2a2">Final Avg % Price Change</span>
                        <div style="height: 10px"></div>

                        <span style="font-size: 14px">{{ activeCycle()?.weightedImpactChangePct | currency : "USD" : "symbol" : "1.2-2" }}</span>
                        <br />
                        <span style="color: #a2a2a2">Final Weighted Avg % Price Change</span>
                        <div style="height: 10px"></div>

                        <span style="font-size: 14px">{{ activeCycle()?.finalRevenueImpact | currency : "USD" : "symbol" : "1.2-2" }}</span>
                        <br />
                        <span style="color: #a2a2a2">Final $ Impact</span>
                     </div>
                  </div>
               </ng-container>
            </div>
         </div>

         <div class="admin-practice-table">
            <vetcor-pricing-table
               [isCaptain]="true"
               [isReadOnly]="isReadOnly"
               [prices]="hospitalPrices()"></vetcor-pricing-table>
         </div>

         <button
            id="rejectAllSureButton"
            data-bs-toggle="modal"
            data-bs-target="#rejectallsure"
            style="display: none"></button>
         <button
            id="approveAllSureButton"
            data-bs-toggle="modal"
            data-bs-target="#approveallsure"
            style="display: none"></button>
      </div>
   </section>
</span>

<!-- Are You Sure Modal -->
<div
   class="modal custom-modal fade"
   id="rejectallsure"
   role="dialog">
   <div
      class="modal-dialog modal-dialog-centered"
      style="min-width: 350px; max-width: 350px">
      <div class="modal-content">
         <div class="modal-body">
            <div
               class="form-header"
               style="text-align: center">
               <h6>This will finalize the product sheet, rejecting any remaining requested prices. Are you sure you want to do this?</h6>
            </div>
            <div
               class="modal-btn confirm-action"
               style="margin-top: 30px">
               <div class="row">
                  <div
                     class="col-6"
                     style="text-align: end; padding-right: 0px">
                     <a
                        href="javascript:void(0);"
                        style="border: 1px solid #cccccc; background-color: #cccccc"
                        data-bs-dismiss="modal"
                        class="btn btn-primary cancel-btn">
                        Cancel
                     </a>
                  </div>
                  <div
                     class="col-6"
                     style="padding-left: 15px; text-align: start">
                     <a
                        href="javascript:void(0);"
                        class="btn btn-primary continue-btn"
                        (click)="rejectAllPricingUpdateRequests_finalize()"
                        data-bs-dismiss="modal">
                        Yes
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>

<!-- Are You Sure Modal -->
<div
   class="modal custom-modal fade"
   id="approveallsure"
   role="dialog">
   <div
      class="modal-dialog modal-dialog-centered"
      style="min-width: 350px; max-width: 350px">
      <div class="modal-content">
         <div class="modal-body">
            <div
               class="form-header"
               style="text-align: center">
               <h6>This will finalize the product sheet, accepting all remaining requested prices. Are you sure you want to do this?</h6>
            </div>
            <div
               class="modal-btn confirm-action"
               style="margin-top: 30px">
               <div class="row">
                  <div
                     class="col-6"
                     style="text-align: end; padding-right: 0px">
                     <a
                        href="javascript:void(0);"
                        style="border: 1px solid #cccccc; background-color: #cccccc"
                        data-bs-dismiss="modal"
                        class="btn btn-primary cancel-btn">
                        Cancel
                     </a>
                  </div>
                  <div
                     class="col-6"
                     style="padding-left: 15px; text-align: start">
                     <a
                        href="javascript:void(0);"
                        class="btn btn-primary continue-btn"
                        (click)="approveAllPricingUpdateRequests_finalize()"
                        data-bs-dismiss="modal">
                        Yes
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
